/**
 * @param {string|undefined} identifier 
 * @returns {string}
 */
function mapIdentifier(identifier) {
  if (identifier) {
    return identifier;
  }

  return '';
}

module.exports = mapIdentifier;
